module.exports = __webpack_public_path__ + "static/media/moon.f83a822c.png";